import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HeadersStore } from '../shared/store/headers.store';
import { environment } from '../../environments/environment';
@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  private readonly TOKEN_KEY = environment.key;

 constructor(
  private headersStore: HeadersStore
  ) {}

  /**
   * @description Interceptor to add Authorization header with Bearer token
   * @param request HttpRequest
   * @param next HttpHandler
   * @returns Observable<HttpEvent<unknown>>
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = request.headers;
    headers = headers.append('Ocp-Apim-Subscription-Key', this.TOKEN_KEY || '');
    const token = this.getToken();
    if (token) {
      headers = headers.append('X-Internal-Token', `${token}`);
    }
    const tokenType = this.headersStore.GetTKNType();
    if (tokenType) {
      headers = headers.append('Authorization', `Bearer ${tokenType}`);
    }
    const clonedRequest = request.clone({ headers });
    return next.handle(clonedRequest);
  }

  /**
   * Obtiene el token del localStorage
   * @returns string | null - El token almacenado o null si no existe
   */
  private getToken(): string | null {
    try {
      let tkn = this.headersStore.GetTKN();
      return `${tkn}`;
    } catch (error) {
      console.error('Error al obtener token del localStorage:', error);
      return null;
    }
  }

}
